import React from "react";
import { Placeholder } from "semantic-ui-react";

const PlaceholderMultiLine = ({ numberLine = 3, style }) => (
  <Placeholder style={style} fluid>
    {[...Array(numberLine)].map((v, key) => <Placeholder.Line key={key} />)}
  </Placeholder>
);

export default PlaceholderMultiLine;